// extracted by mini-css-extract-plugin
export var cardLayout = "_85-1";
export var paginationContainer = "_85-0";